// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-inscription-view-for-data-modal__container_data {
    display: flex;
    flex-direction: column;
    padding: 35px 60px;
}

.tournament-inscription-view-for-data-modal__question{
    display: flex;
    flex-direction: column;
    padding-bottom: 27px;
}

.tournament-inscription-view-for-data-modal__question img {
    width: 175px;
    height: 175px;
}

.tournament-inscription-view-for-data-modal__question__caption.baloa-username{
    color: var(--primary-very-dark-color);
    padding-bottom: 4px;
}

.tournament-inscription-view-for-data-modal__question__answer.baloa-table{
    color: var(--primary-very-dark-color);
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    box-sizing: border-box;
    border-radius: 8px;
    padding: 15px 12px;
}

.tournament-inscription-view-for-data-modal__question__download{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    color: var(--new-green-color);
    background: var(--white-color);
    border: 1px solid var(--new-gray-color);
    box-sizing: border-box;
    border-radius: 5px;
    max-width: 160px;
    padding: 10px;
}

.tournament-inscription-view-for-data-modal__question__download .hubicon-file_download{
    margin-right: 10px;
    color: var(--new-green-color);
}

.tournament-inscription-view-for-data-modal__question__single-choice .MuiTypography-body1{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.15px;
    color: var(--primary-dark-color);
}

.tournament-inscription-view-for-data-modal__question__multiple-choice .MuiTypography-body1{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.15px;
    color: var(--primary-dark-color);
}

.tournament-inscription-view-for-data-modal__question__answer.list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 200px;
}

.tournament-inscription-view-for-data-modal__question__answer.list span {
    font-size: var(--space-and-half);
    color: var(--basic-gray-color);
}

.tournament-inscription-view-for-data-modal__question__answer.date {
    max-width: 200px;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-inscription-view-form-data-modal/TournamentInscriptionViewFormDataModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,8BAA8B;IAC9B,kDAAkD;IAClD,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,6BAA6B;IAC7B,8BAA8B;IAC9B,uCAAuC;IACvC,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".tournament-inscription-view-for-data-modal__container_data {\n    display: flex;\n    flex-direction: column;\n    padding: 35px 60px;\n}\n\n.tournament-inscription-view-for-data-modal__question{\n    display: flex;\n    flex-direction: column;\n    padding-bottom: 27px;\n}\n\n.tournament-inscription-view-for-data-modal__question img {\n    width: 175px;\n    height: 175px;\n}\n\n.tournament-inscription-view-for-data-modal__question__caption.baloa-username{\n    color: var(--primary-very-dark-color);\n    padding-bottom: 4px;\n}\n\n.tournament-inscription-view-for-data-modal__question__answer.baloa-table{\n    color: var(--primary-very-dark-color);\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    box-sizing: border-box;\n    border-radius: 8px;\n    padding: 15px 12px;\n}\n\n.tournament-inscription-view-for-data-modal__question__download{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 16px;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    color: var(--new-green-color);\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-color);\n    box-sizing: border-box;\n    border-radius: 5px;\n    max-width: 160px;\n    padding: 10px;\n}\n\n.tournament-inscription-view-for-data-modal__question__download .hubicon-file_download{\n    margin-right: 10px;\n    color: var(--new-green-color);\n}\n\n.tournament-inscription-view-for-data-modal__question__single-choice .MuiTypography-body1{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 24px;\n    letter-spacing: 0.15px;\n    color: var(--primary-dark-color);\n}\n\n.tournament-inscription-view-for-data-modal__question__multiple-choice .MuiTypography-body1{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 24px;\n    letter-spacing: 0.15px;\n    color: var(--primary-dark-color);\n}\n\n.tournament-inscription-view-for-data-modal__question__answer.list {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    max-width: 200px;\n}\n\n.tournament-inscription-view-for-data-modal__question__answer.list span {\n    font-size: var(--space-and-half);\n    color: var(--basic-gray-color);\n}\n\n.tournament-inscription-view-for-data-modal__question__answer.date {\n    max-width: 200px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
